//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconTeamFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.79 3H2V21H22V5H12.47L10.79 3ZM10.25 9.5C11.08 9.5 11.75 10.17 11.75 11C11.75 11.83 11.08 12.5 10.25 12.5C9.42 12.5 8.75 11.83 8.75 11C8.75 10.17 9.42 9.5 10.25 9.5ZM15.75 9.5C16.58 9.5 17.25 10.17 17.25 11C17.25 11.83 16.58 12.5 15.75 12.5C14.92 12.5 14.25 11.83 14.25 11C14.25 10.17 14.92 9.5 15.75 9.5ZM17.91 14L18.64 16H14.92L14.19 14H17.91ZM13.32 16H7.36L8.09 14H12.59L13.32 16Z" fill="currentColor" /></svg>;
}
export default IconTeamFill;